import React from 'react';
import { Grid, TextField } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import { FDataGrid } from '../grid';

type Props = { rows: any[]; targetsetcode: string; loading?: boolean; onTargetSetChange: (code: string) => void };

class SimulationObjectiveImpactPanel extends React.PureComponent<Props> {
  columns: GridColDef[] = [
    { field: 'objectivecode', headerName: 'Objective', width: 140 },
    { field: 'objectivename', headerName: 'Name', flex: 1, minWidth: 260 },
    { field: 'priority', headerName: 'Priority', width: 120 },
    { field: 'weight', headerName: 'Weight', width: 100, type: 'number' },
    { field: 'targetvalue', headerName: 'Target', width: 140, type: 'number' },
    { field: 'actualvalue', headerName: 'Simulation', width: 140, type: 'number' },
    { field: 'gapvalue', headerName: 'Gap', width: 140, type: 'number' },
    { field: 'status', headerName: 'Status', width: 130 },
    { field: 'recommendation', headerName: 'Recommended Action', flex: 1, minWidth: 260 },
  ];
  getRowId = (r: any) => r.objectiveid || r.objectivecode || r.id;

  render() {
    return (
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 4 }}><TextField label="Target Set" size="small" value={this.props.targetsetcode} onChange={(e) => this.props.onTargetSetChange(e.target.value.toUpperCase())} fullWidth /></Grid>
        <Grid size={{ xs: 12 }}><FDataGrid title="Objective Impact" subtitle="Compare simulation output against the selected target set." rows={this.props.rows || []} columns={this.columns} loading={this.props.loading} height={520} showQuickFilter toolbarSx={{ backgroundColor: '#fff8e1' }} getRowId={this.getRowId} pageSizeOptions={[10, 25, 50]} /></Grid>
      </Grid>
    );
  }
}
export default SimulationObjectiveImpactPanel;
